<template>
  <div id="app">
    <Navbar />
    <div class="app-content">
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
import Navbar from "./ui/Navbar.vue";
export default {
  components: {
    Navbar,
  },
  data() {},
};
</script>
<style>
#app {
  font-family: "Montserrat", sans-serif;
  width: 70vw;
  margin: 40px auto;
}
.app-content {
  margin-top: 1%;
}

::-webkit-scrollbar {
  width: 0.5vw;
}

::-webkit-scrollbar-track {
  background: #222121;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 50px;
}

::-webkit-scrollbar-thumb:hover {
  background: #ffbb00;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s, transform 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translate(-30%);
}

/*****************************************************/
@media only screen and (max-width: 1032px) {
    #app {
    margin-top: 5%;
    width: 90%;
  }
}

/* Small phones to small tablets: from 481 to 767*/
@media only screen and (max-width: 767px) {
  #app {
    margin-top: 5%;
    width: 95%;
  }
}

/*Small Phone from 0 to 480px*/
@media only screen and (max-width: 400px) {
  #app {
    margin-top: 5%;
    width: 95%;
  }
}
</style>
